// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productDetailsVideosStyles } from "@conklin/App/Widgets/ProductDetails/ProductDetailsVideos";
import { hideElementOnPrint, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

productDetailsVideosStyles.wrapper = { css: hideElementOnPrint };

productDetailsVideosStyles.videosContainer = {
    css: css`
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(317px, 1fr));
        gap: 16px 22px;
        ${xScreen("lte", "lg")} {
            grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
        }
        ${xScreen("lte", "xs")} {
            grid-template-columns: repeat(auto-fill, minmax(328px, 1fr));
        }

        ${hideElementOnPrint};
    `,
};

productDetailsVideosStyles.videoContainer = {
    width: [12, 4, 4, 4, 4],
    css: css`
        &&& {
            flex: 1;
        }

        ${xScreen("lte", "md")} {
            &&&& {
                max-width: 100%;
            }
        }
    `,
};

productDetailsVideosStyles.imageWrapper = {
    css: css`
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 179px;
        min-width: 317px;
        & > div {
            height: 100%;
            width: 100%;
            article {
                height: 179px;
                width: 100%;
            }
        }
        ${xScreen("lte", "md")} {
            min-width: 230px;
        }
        ${xScreen("lte", "xs")} {
            min-width: 328px;
        }

        ${hideElementOnPrint};
    `,
};

productDetailsVideosStyles.video = {
    container: {
        css: css`
            ${hideElementOnPrint};
        `,
    },
};
